import {Exclude, Expose} from "class-transformer";

@Exclude()
export class TokenApiModel {
  @Expose() public token: string;
  @Expose() public pin?: string;
}
